var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackRewind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3077 5.53938L10.1825 11.9861L20.3077 18.4329V5.53845V5.53938Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9231 5.53938L2.79785 11.9861L12.9231 18.4329V5.53845V5.53938Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackRewind);
export default __webpack_public_path__ + "static/media/track-rewind.843cd22cc45f10d2cd96d93d16f7633a.svg";
export { ForwardRef as ReactComponent };